import React, { useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Button from 'common-ui/button';
import Pagination from 'common-ui/table/Pagination';
import dayjs from 'dayjs';
import { selectUserInfo } from 'features/auth/authSlice';
import {
  checkErpCredentials,
  getMyAppointments,
} from 'features/myAppointments/MyAppointmentsActions';
import {
  selectHasErpCredentials,
  selectTotal,
} from 'features/myAppointments/MyAppointmentsSlice';

import { Container, Header, PageTitle, SegmentedControl } from './MyAppointments.styles';
import AppointmentsList from './appointmentsList';
import ErpCredentialsModal from './erpCredentialsModal/ErpCredentialsModal';
import OverviewSection from './overviewSection';
import Toolbar from './toolbar';
import { useMyAppointmentsSearchParams } from './toolbar/useSearchData';

const MyAppointments = () => {
  const dispatch = useDispatch();

  const { searchData, setSearchData } = useMyAppointmentsSearchParams();
  const total = useSelector(selectTotal);
  const userInfo = useSelector(selectUserInfo);
  const hasErpCredentials = useSelector(selectHasErpCredentials);
  const [erpModalOpen, setErpModalOpen] = useState(false);

  const currentPage = useMemo(
    () => Math.floor((searchData.offset || 0) / (searchData.limit || 12)) + 1,
    [searchData.offset, searchData.limit]
  );

  const totalPages = useMemo(
    () => Math.ceil(total / (searchData.limit || 12)),
    [total, searchData.limit]
  );

  const onPaginationChange = (page) => {
    setSearchData({ offset: (page - 1) * searchData.limit });
  };

  const handleRowCountChange = (newLimit) => {
    setSearchData({ limit: newLimit, offset: 0 });
  };

  useEffect(() => {
    if (userInfo?.email) {
      dispatch(checkErpCredentials(userInfo.email));
    }
  }, [userInfo?.email]);
  console.log(hasErpCredentials);
  useEffect(() => {
    if (hasErpCredentials === false) {
      setErpModalOpen(true);
    } else {
      setErpModalOpen(false);
    }
  }, [hasErpCredentials]);

  useEffect(() => {
    dispatch(
      getMyAppointments({
        ...searchData,
        today: dayjs().format('YYYY-MM-DD'),
      })
    );
  }, [searchData]);

  return (
    <Container>
      <ErpCredentialsModal isOpen={erpModalOpen} onClose={() => setErpModalOpen(false)} />
      <Header>
        <PageTitle />
        <SegmentedControl>
          <Button
            className={searchData.quickFilter === 'Today' ? 'active' : ''}
            onClick={() => setSearchData({ quickFilter: 'Today' })}
          >
            Today
          </Button>

          <Button
            className={searchData.quickFilter === 'This Week' ? 'active' : ''}
            onClick={() => setSearchData({ quickFilter: 'This Week' })}
          >
            This Week
          </Button>

          <Button
            className={searchData.quickFilter === 'All' ? 'active' : ''}
            onClick={() => setSearchData({ quickFilter: 'All' })}
          >
            All
          </Button>
        </SegmentedControl>
      </Header>
      <OverviewSection />
      <Toolbar />
      <AppointmentsList />
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPaginationChange}
          dataCount={total}
          count={searchData.limit}
          editableRowCount
          handleRowCountChange={handleRowCountChange}
          pageOptions={[12, 25, 50, 100]}
        />
      )}
    </Container>
  );
};

export default MyAppointments;
